export enum BOOK_CODES {
  MY_FIRST_SCHOOL_BOOK = 'MFSB',
  MY_FIRST_LOWERCASE_BOOK = 'MFLB',
  I_KNOW_MY_NUMBERS = 'IKMN',
  MY_BOOK = 'MB',
  MATMAN_ON_THE_GO = 'MMGO',
  MATMAN_HATS = 'MMHATS',
  MATMAN_OPPOSITES = 'MMOPP',
  MATMAN_SHAPES = 'MMSH'
}

export enum BOOK_CODE_DESCRIPTIONS {
  KSK = 'Kick Start Kindergarten',
  LN = 'Letters and Numbers for Me',
  PP = 'Printing Power',
  MPB = 'My Printing Book',
  CH = 'Cursive Handwriting',
  CS = 'Cursive Success',
  CK = 'Cursive Kickoff',
  DC = 'Can-Do Cursive',
  SCK = 'Comencemos con Kinder',
  SKLY = 'Letras y Números Para Mí',
  S1MLI = 'Mi Libro de Escribir Imprenta',
  S2EPI = 'El Poder De La Imprenta',
  S2AC = 'Aventuras en Cursiva',
  S3EC = 'Escribiendo Cursiva',
  S4XC = 'Éxito con Cursiva',
  S5DC = 'Domino Cursiva'
}

export enum TEACHER_GUIDE_DESCRIPTIONS {
  TGKSK = 'Kick Start Kindergarten',
  TGLN = 'Letters and Numbers for Me',
  TGPP = 'Printing Power',
  TGMPB = 'My Printing Book',
  TGCH = 'Cursive Handwriting',
  TGCS = 'Cursive Success',
  TGDC = 'Can-Do Cursive',
  TGCK = 'Cursive Kickoff',
  TGSCK = 'Comencemos con Kinder',
  TGSKLY = 'Letras y Números Para Mí',
  TGS1MLI = 'Mi Libro de Escribir Imprenta',
  TGS2EPI = 'El Poder De La Imprenta',
  TGS2AC = 'Aventuras en Cursiva',
  TGS3EC = 'Escribiendo Cursiva',
  TGS4XC = 'Éxito con Cursiva',
  TGS5DC = 'Domino Cursiva'
}

export enum RESOURCE_TYPES {
  CLICK_AWAY = 'clickAway',
  WOOD_PIECES = 'woodPieces',
  LNF = 'lnf',
  WDT = 'wdt',
  ANIMATION = 'animation',
  MUSIC = 'music',
  VIDEO = 'video',
  OUR_WORLD = 'ourWorld',
  PDF = 'pdf',
  SUPPORT = 'support',
  KARAOKE = 'karaoke',
  AUDIO = 'audio',
  IFRAME_PLAYER = 'IFRAME_PLAYER',
  AV_PLAYER = 'AV_PLAYER'
}

export enum TYPOGRAPHY_TYPES {
  ASCENDER = 'ascender',
  DESCENDER = 'descender',
  PLAIN = 'plain'
}

export enum Tags {
  ACLICKAWAY = 'A Click Away'
}
export enum SETTING_TYPES {
  LOCALE = 'locale',
  LICENSING = 'licensing',
  SUPPRESSED_EXPIRATION_ALERTS = 'suppressedExpirationAlerts',
  SUPPRESS_2025_SWITCH = 'suppress2025Modal'
}

export enum DRAG_DROP_TYPES {
  PAPER_CARD = 'PAPER_CARD'
}

export enum LESSON_PLANNER_MODE {
  LESSON_PLANNER = 'LESSON_PLANNER',
  ASSIGNMENTS = 'ASSIGNMENTS'
}

export enum LESSON_PLANNER_VIEW {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month'
}

export enum WORKBOOK_TYPE {
  TEACHERS_GUIDE = 'teachersGuide',
  STUDENT_WORKBOOK = 'studentWorkbook'
}

export enum ATTEMPT_STATUS {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed'
}

export enum MESSAGE_SENDER {
  EDUCATOR = 'educator',
  STUDENT = 'student'
}

export enum MIME_TYPE {
  MPEG = 'audio/mpeg',
  MP3 = 'audio/mp3',
  AUDIO_MP4 = 'audio/mp4',
  AUDIO_M4A = 'audio/x-m4a',
  WAV = 'audio/wav',
  WAVE = 'audio/wave',
  AUDIO_WEBM = 'audio/webm',
  MP4 = 'video/mp4',
  WEBM = 'video/webm',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  WEBP = 'image/webp',
  APPLICATION_PDF = 'application/pdf'
}

export enum ASSIGNMENT_VIEW_TYPE {
  ASSIGNMENTS = 'Assignments',
  MESSAGES = 'Messages'
}

export enum Headers {
  APP_TARGET = 'x-lwtears-app-target'
}

export enum AppNames {
  GSS = 'gss'
}
